export const site = {
  name: 'Goelst France S.A.R.L',
  category: 'Rails à rideaux',
  since: 1978,
  logo: 'https://cdn.magicpatterns.com/uploads/4awR4fbbVysNbAGtKjvyYX/aaLogo.jpg',
  address: {
    street: '869 Avenue des Chênes Verts',
    city: 'Bignoles',
    region: 'Provence-Alpes-Côte d’Azur',
    postalCode: '83170',
    country: 'France',
  },
  addressLine: '869 Avenue des Chênes Verts, Bignoles, Provence-Alpes-Côte d’Azur 83170, France',
  phoneDisplay: '0033 (0)4 946 974 28',
  phoneHref: 'tel:+33494697428',
  email: 'info@g-rail-france.fr',
  emailHref: 'mailto:info@g-rail-france.fr',
  website: 'https://goelst-international.com/',
  instagram: 'https://www.instagram.com/goelst_international/',
  hours: [
    { days: 'Lundi – Vendredi', time: '09:00 – 18:00' },
    { days: 'Samedi', time: 'Fermé' },
    { days: 'Dimanche', time: 'Fermé' },
  ],
  mapEmbed:
    'https://www.google.com/maps?q=869+Avenue+des+Ch%C3%AAnes+Verts,+83170+Brignoles,+France&output=embed',
  mapLink:
    'https://www.google.com/maps/search/?api=1&query=869+Avenue+des+Ch%C3%AAnes+Verts,+83170+Brignoles,+France',
}

export const nav = [
  { label: 'Accueil', to: '/' },
  { label: 'À propos', to: '/a-propos' },
  { label: 'Solutions', to: '/solutions' },
  { label: 'Ressources', to: '/ressources' },
  { label: 'Contact', to: '/contact' },
]

export const images = {
  heroLiving: 'https://cdn.magicpatterns.com/uploads/sd3dwMZEJx1RdfbYHLgo4q/Screenshot_2.jpg',
  warmLiving: 'https://cdn.magicpatterns.com/uploads/ccWDTzD7abAvE2UxHALte2/aCover.jpg',
  railManual: 'https://cdn.magicpatterns.com/uploads/vD4HGAGLMEAHR9PimE4Cu7/Screenshot_3.jpg',
  railMulti: 'https://cdn.magicpatterns.com/uploads/kn6vp5hvvQ1HXwLLoGmnJ2/Screenshot_4.jpg',
  railMotor: 'https://cdn.magicpatterns.com/uploads/rkiVK6os6ihQ7ATfjtMy8R/Screenshot_7.jpg',
  salonBeige: 'https://cdn.magicpatterns.com/uploads/ufJomxFF5W8XJpH4mkyCZQ/Screenshot_5.jpg',
  seaView: 'https://cdn.magicpatterns.com/uploads/iK4HeQxc13cG1DJ57FuHXn/Screenshot_6.jpg',
  sheerWhite: 'https://cdn.magicpatterns.com/uploads/eLEHcwmT4iHcsNoMQEuzST/Screenshot_8.jpg',
}
